import React, { Component } from "react";

export default class Spinner extends Component {
  render() {
    return (
      <div className="load-container spinner">
        <div className="loader" style={{ color: this.props.color }}>
          Loading...
        </div>
      </div>
    );
  }
}
